import { Link } from 'react-router-dom';
import { Brain, Mail, MapPin, Github, Linkedin, Twitter } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="relative border-t border-white/5 bg-black py-24 overflow-hidden" data-testid="footer">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-[#C6FF00]/20 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-5 space-y-8">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="w-10 h-10 bg-white/5 rounded-xl flex items-center justify-center border border-white/10 group-hover:border-[#C6FF00]/50 transition-colors">
                <Brain className="w-6 h-6 text-white group-hover:text-[#C6FF00] transition-colors" />
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-black tracking-tighter leading-none text-white">BUILD</span>
                <span className="text-xs font-black tracking-[0.4em] text-[#C6FF00] leading-none mt-1">BRAINS</span>
              </div>
            </Link>
            <p className="text-white/40 text-lg font-medium leading-relaxed max-w-sm">
              Definiendo la frontera digital a través de ingeniería de élite y diseño visionario.
            </p>
            <div className="flex space-x-6">
              {[Github, Linkedin, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-[#C6FF00] hover:border-[#C6FF00]/50 transition-all duration-300">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
          
          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-12">
            <div>
              <h3 className="text-white font-black uppercase tracking-[0.2em] text-[10px] mb-8">Capacidades</h3>
              <ul className="space-y-4">
                {['Software', 'App Store', 'Operaciones Digitales', 'Estrategia'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-white/40 hover:text-white transition-colors text-sm font-bold tracking-tight">{item}</a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-black uppercase tracking-[0.2em] text-[10px] mb-8">Ecosistema</h3>
              <ul className="space-y-4">
                {[
                  { name: 'Nosotros', path: '/nosotros' },
                  { name: 'Noticias', path: '/noticias' },
                  { name: 'Planes', path: '/planes' },
                  { name: 'Trabajos', path: '/apps' }
                ].map((item) => (
                  <li key={item.name}>
                    <Link to={item.path} className="text-white/40 hover:text-white transition-colors text-sm font-bold tracking-tight">{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="col-span-2 sm:col-span-1">
              <h3 className="text-white font-black uppercase tracking-[0.2em] text-[10px] mb-8">Conectar</h3>
              <ul className="space-y-4">
                <li className="flex items-center space-x-3 text-white/40">
                  <Mail size={14} className="text-[#C6FF00]" />
                  <span className="text-sm font-bold tracking-tight">ops@buildbrains.io</span>
                </li>
                <li className="flex items-center space-x-3 text-white/40">
                  <MapPin size={14} className="text-[#C6FF00]" />
                  <span className="text-sm font-bold tracking-tight">Global / Remoto</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="mt-24 pt-12 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-6">
          <p className="text-white/20 text-[10px] font-black uppercase tracking-[0.4em]">
            © {currentYear} BUILD BRAINS / TODOS LOS DERECHOS RESERVADOS
          </p>
          <div className="flex space-x-8">
            <Link to="/privacidad" className="text-white/20 hover:text-white transition-colors text-[10px] font-black uppercase tracking-widest">Privacidad</Link>
            <Link to="/terminos" className="text-white/20 hover:text-white transition-colors text-[10px] font-black uppercase tracking-widest">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
